import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import '@webModules/form';
import { logCustomMessage } from '@shared/easyfy.logger';

@invoke
export default class Review {
  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'check-rating',
          callback: Review.onClickStar,
        },
      ],
    });
  }

  static onClickStar(e: Event): void {
    e.preventDefault();

    if (!(e.target instanceof HTMLElement)) return;
    const element = e.target;

    const radio = element.querySelector('input');
    const container = element.closest('[data-container="rating-container"]');
    const ratingItems = container?.querySelectorAll('[data-event="check-rating"]');
    const checkedClass = container?.getAttribute('data-checked-class');
    const unCheckedClass = container?.getAttribute('data-unchecked-class');

    if (!radio || !container || !ratingItems || !checkedClass || !unCheckedClass) {
      logCustomMessage('Review.onClickStar: Missing required elements or attributes', {
        missingElements: `${!radio ? 'radio ' : ''}${!container ? 'container ' : ''}${!ratingItems ? 'ratingItems ' : ''}${!checkedClass ? 'checkedClass ' : ''}${!unCheckedClass ? 'unCheckedClass ' : ''}`,
      });
      return;
    }

    radio.checked = true;
    const selectedValue = Number(radio.value);

    ratingItems.forEach((item, index) => {
      const icon = item.querySelector('i');
      if (!icon) return;

      icon.classList.toggle(checkedClass, index < selectedValue);
      icon.classList.toggle(unCheckedClass, index >= selectedValue);
    });
  }
}
